<template>
  <layout background="bg-gradient-light" class="text-color-regular bg-chplus">
    <box-title-l :lines="2" class="relative px-4">
      <div
        class="absolute top-0 w-12"
        style="margin: 0;left: -1rem; height: 1.4em;"
      >
        <back-button
          class="absolute left-0 text-nav-light"
          style="left: 50%; top: 50%;transform:translate(-50%, -50%)"
          :back-action="() => $router.push({ name: 'start' })"
        />
      </div>
      {{ $t("views.user.forgot_password.title") }}</box-title-l
    >
    <box-title-sub-s>{{
      $t("views.user.forgot_password.subtitle")
    }}</box-title-sub-s>
    <box-logo />
    <content-scroll-container>
      <content-scroll-inner class="text-chplus-regular">
        <template v-if="!hasSentLink">
          <h3 class="font-bold">
            {{ $t("views.user.forgot_password.title") }}
          </h3>
          <form @submit.prevent="onSubmit">
            <content-form>
              <div class="text-red-500 my-2" v-show="errors.length !== 0">
                <div v-for="(error, index) in errors" :key="index">
                  {{ error }}
                </div>
              </div>
              <input
                v-model="email"
                name="email"
                type="email"
                class="text-chplus-regular"
                :placeholder="$t('views.register.placeholder_email')"
              />
              <input
                class="bg-gradient-blue text-chplus-regular font-bold login-btn cursor-pointer disabled:opacity-50"
                type="submit"
                :disabled="isSending"
                :value="$t('views.user.forgot_password.button_send_reset')"
              />
            </content-form>
          </form>
        </template>
        <template v-else>
          <p class="mb-4">
            {{ $t("views.user.forgot_password.info_link_sent", { email }) }}
          </p>
          <content-form>
            <router-link :to="{ name: 'start' }">
              <input
                class="bg-gradient-blue text-chplus-regular font-bold login-btn cursor-pointer"
                type="submit"
                :value="$t('views.user.forgot_password.go_to_login')"
              />
            </router-link>
          </content-form>
        </template>
      </content-scroll-inner>
    </content-scroll-container>
  </layout>
</template>

<script>
import Layout from "@/components/layouts/LayoutEnvelope";
import ContentScrollContainer from "@/components/layouts/ContentScrollContainer";
import { mapActions } from "vuex";
import BoxTitleL from "@/components/layouts/BoxTitleL";
import BoxTitleSubS from "@/components/layouts/BoxTitleSubS";
import BoxLogo from "@/components/layouts/BoxLogo";
import ContentScrollInner from "@/components/layouts/ContentScrollInner";
import BackButton from "@/components/buttons/BackButton";
import ContentForm from "@/components/layouts/ContentForm";

export default {
  name: "ForgotPassword",
  components: {
    ContentForm,
    BackButton,
    ContentScrollInner,
    BoxLogo,
    BoxTitleSubS,
    BoxTitleL,
    ContentScrollContainer,
    Layout
  },
  data: () => ({
    errors: [],
    email: "",
    hasSentLink: false,
    isSending: false
  }),
  methods: {
    ...mapActions("user", ["requestPasswordReset"]),
    async onSubmit() {
      this.errors = [];
      if (!this.email) {
        this.errors.push(this.$t("components.user.login.error_email"));
      }

      if (this.errors.length !== 0) {
        return;
      }

      try {
        this.isSending = true;
        await this.requestPasswordReset({ email: this.email });
        this.hasSentLink = true;
      } catch (e) {
        this.errors.push(this.$t(e.response.data.messageKey));
      }
      this.isSending = false;
    }
  }
};
</script>

<style lang="scss" scoped>
input[type="email"] {
  @apply w-full p-2 my-1 rounded-lg text-center border-2 leading-tight bg-transparent;
  border-color: #5b7ff7;
  margin: 0.5rem 0;
}

input[type="submit"] {
  @apply w-full px-3 my-1 rounded-lg text-white align-middle;
  line-height: 1em;
  margin: 0.5rem 0;
}

.register-btn {
  width: 9.5rem;
  height: 2.3125rem;
}

.login-btn {
  width: 14.625rem;
  height: 2.875rem;
}

@media (min-width: 768px) {
  .register-btn {
    width: 11.125rem;
    height: 2.625rem;
  }

  .login-btn {
    width: 16.9375rem;
    height: 3.125rem;
  }
}
</style>
